import { ActorType, ScopeType } from './operation.js';
import * as OID from './operation-ids.js';
export const MAINTENANCE_DELEGATION_SESSION_OPERATION_IDS = Object.freeze([
    OID.AUTH_LOGOUT,
    OID.AUTH_READ_PROFILE,
    OID.AUTH_EXIT_DELEGATION,
    OID.NAVIGATION_SHELL_READ,
    OID.NAVIGATION_ROUTES_READ,
    OID.NAVIGATION_ROUTE_READ,
    OID.NAVIGATION_HUB_READ,
    OID.SETTINGS_VIEW,
    OID.SETTINGS_PROFILE,
    OID.SETTINGS_PREFERENCES,
]);
const SESSION_OPERATION_ID_SET = new Set(MAINTENANCE_DELEGATION_SESSION_OPERATION_IDS);
const MAINTENANCE_DELEGABLE_ORGANIZATION_PREFIXES = Object.freeze([
    'organization.profile.',
    'organization.modules.',
    'organization.branches.',
    'organization.users.',
    'organization.roles.',
    'organization.permissions.',
    'organization.permission-assignments.',
    'organization.audit.',
    'organization.legal-hold.',
    'organization.access-inspector.',
    'admin.organization.',
    'admin.modules.',
]);
export function isMaintenanceDelegationSessionOperation(operationId) {
    return SESSION_OPERATION_ID_SET.has(operationId);
}
export function isMaintenanceDelegableOrganizationOperation(operationId) {
    return MAINTENANCE_DELEGABLE_ORGANIZATION_PREFIXES.some((prefix) => operationId.startsWith(prefix));
}
function operationMutates(operation) {
    return operation.httpMethods.some((method) => ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method.toUpperCase()));
}
export function normalizeMaintenanceDelegationOperation(operation) {
    const sessionOperation = isMaintenanceDelegationSessionOperation(operation.id);
    const organizationOperation = isMaintenanceDelegableOrganizationOperation(operation.id);
    if (!sessionOperation && !organizationOperation)
        return {};
    const actorTypes = new Set(operation.allowedActorTypes ?? []);
    actorTypes.add(ActorType.SUPPORT_DELEGATE);
    const scopeTypes = new Set(operation.scopeTypes ?? []);
    scopeTypes.add(ScopeType.ORGANIZATION);
    scopeTypes.add(ScopeType.BRANCH);
    const allowedScopeKinds = operation.allowedScopeKinds?.length
        ? new Set([...operation.allowedScopeKinds, 'ORGANIZATION', 'BRANCH'])
        : undefined;
    const allowedPersonas = operation.allowedPersonas?.length
        ? new Set([
            ...operation.allowedPersonas,
            'ORG_ADMIN',
            'PLATFORM_ROOT',
            'PLATFORM_ADMIN',
        ])
        : undefined;
    return {
        allowedActorTypes: Array.from(actorTypes),
        scopeTypes: Array.from(scopeTypes),
        ...(allowedScopeKinds
            ? { allowedScopeKinds: Array.from(allowedScopeKinds) }
            : {}),
        ...(allowedPersonas
            ? { allowedPersonas: Array.from(allowedPersonas) }
            : {}),
        supportDelegationEligible: true,
        ...(operation.isReadOnly ? { accessType: 'READ' } : {}),
        delegationPolicy: sessionOperation
            ? 'EXPLICITLY_GRANTED'
            : operationMutates(operation)
                ? 'EXPLICITLY_GRANTED'
                : 'READ_ONLY',
    };
}
